import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatisEsrs = () => {
  const urlConfig = {
    name: "Esrs.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/ESRS.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="CSRD/ESRS (EU)"
            title={"CSRD-ESRS Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What is ESRS? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
              }}
            >
              The European Sustainability Reporting Standards (ESRS) are the
              detailed technical standards under CSRD that specify what
              companies must disclose and how they should report ESG
              information.{" "}
            </Typography>
          </Box>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
              mb: 2,
            }}
          >
            Developed by EFRAG (European Financial Reporting Advisory Group),
            the ESRS cover:
            <ul
              style={{
                paddingLeft: "1.5rem",
                marginTop: "8px",
                marginBottom: "8px",
              }}
            >
              <li>
                General disclosures (e.g., governance, strategy, business model)
              </li>
              <li>
                Environmental topics (e.g., climate change, biodiversity,
                pollution)
              </li>
              <li>Social topics (e.g., workers, communities, human rights)</li>
              <li>Governance topics (e.g., business conduct)</li>
            </ul>
            These standards are designed to ensure consistent, comparable, and
            verifiable sustainability information across companies and sectors
            in line with EU policy goals.
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <DownloadZipButton
            config={urlConfig}
            title="Access Link to full ESRS Disclosure"
          /> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatisEsrs;
